/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.list.admin.order.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.calendar',
  'acme.common.factory.notice',
  'acme.common.service.userPreferences'
])

.controller('ProgramsListAdminOrderController', ['$scope', '$state', '$filter', '$timeout', 'EventData', 'SourceData', 'ApiService', 'CalendarService', 'NoticeFactory', 'UserPreferencesService', function($scope, $state, $filter, $timeout, EventData, SourceData, ApiService, CalendarService, NoticeFactory, UserPreferencesService) {

    $scope.programsListAdminOrder = {

      model: {
        eventId: '',
        contactFirstName: '',
        contactLastName: '',
        sourceName: '',
        notes: '',
        items: []
      },

      noticeTimer: '',
      quantity: 0,
      total: 0,
      source: '',

      sources: [],

      event: {},
      notice: {},
      hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
      dateFormat: UserPreferencesService.getDateFormat('shortDate', 'dateFormat'),

      init: function() {

        $scope.$emit('Application::contentTitleChange', {
          title: 'Create Order',
          buttonLeft: {
            label: 'Cancel',
            action: function() {
              $scope.programsListAdminOrder.cancel();
            }
          }
        });

        if (EventData && EventData.data.success) {
          this.success.init(EventData);
        }else{
          this.error.init(EventData);
        }

        if (SourceData && SourceData.data.success) {
          this.success.initSources(SourceData);
        }else{
          this.error.initSources(SourceData);
        }

        this.notice = new NoticeFactory();

      },

      resetModel: function() {

        this.model.contactFirstName = '';
        this.model.contactLastName = '';
        this.model.sourceName = '';
        this.model.notes = '';
        this.model.items = [];

        this.quantity = 0;
        this.total = 0;
        this.source = '';

      },

      process: function(event) {
        event.startDate =  $filter('date')(CalendarService.parseDate(event.startTime), this.dateFormat);
        event.startHour =  $filter('date')(CalendarService.parseDate(event.startTime), this.hourFormat);

        return event;
      },

      calculateTotal: function() {
        var i, ii,
            total = 0,
            quantity = 0;

        for (i=0,ii=this.event.priceList.prices.length;i<ii;i++) {
          if (this.event.priceList.prices[i].quantity >= 0) {
            quantity += this.event.priceList.prices[i].quantity;
            if (this.event.priceList.prices[i].price >= 0) {
              total += this.event.priceList.prices[i].quantity * this.event.priceList.prices[i].price;
            }
          }
        }

        this.quantity = quantity;
        this.total = total;
      },

      calculatePrice: function(category) {
        var price = category.price * category.quantity;

        return price || 0;
      },

      migrate: function() {
        var i, ii;

        // New entries are captured as strings
        if (typeof(this.source) === 'string' && this.source.replace(/\s+/,'').length > 0) {
          this.model.sourceName = this.source;
          // Since it's a new entry make sure we add it to the sources list while we're at it
          this.sources.push({ sourceName: this.source });
        }else if (this.source.hasOwnProperty('sourceName')) {
          // Existing entries are objects with sourceName properties
          if (this.source.sourceName && this.source.sourceName.replace(/\s+/,'').length > 0) {
            this.model.sourceName = this.source.sourceName;
          }else{
            this.model.sourceName = null;
          }
        }else{
          this.model.sourceName = null;
        }

        this.model.items = [];

        for (i=0,ii=this.event.priceList.prices.length;i<ii;i++) {
          this.model.items.push({
            personTypeId: this.event.priceList.prices[i].personType.id,
            quantity: (this.event.priceList.prices[i].quantity >= 0) ? this.event.priceList.prices[i].quantity : 0,
            unitPrice: (this.event.priceList.prices[i].price >= 0) ? this.event.priceList.prices[i].price : 0
          });
          this.event.priceList.prices[i].quantity = 0;
        }

      },

      complete: function() {
        if (this.quantity > 0) {
          this.migrate();
          this.notice.hideSuccessMessages();
          this.notice.hideErrorMessages();
          ApiService.walkins.orders.create(this.model).then(this.success.complete, this.error.complete);
        }else{
          this.notice.showErrorMessages([
            { message: 'You must add tickets to the order.' }
          ]);
        }
      },

      cancel: function() {
        $state.go('application.programs.list');
      },

      success: {
        init: function(response) {
          $scope.programsListAdminOrder.event = $scope.programsListAdminOrder.process(response.data.payload);
          $scope.programsListAdminOrder.model.eventId = $scope.programsListAdminOrder.event.id;
        },
        initSources: function(response) {
          $scope.programsListAdminOrder.sources = response.data.payload;
        },

        complete: function(response) {
          $scope.programsListAdminOrder.notice.hideSuccessMessages();
          $scope.programsListAdminOrder.notice.hideErrorMessages();
          $scope.programsListAdminOrder.resetModel();
          $state.go('application.orders.detail.summary', { orderId: response.data.payload });
        }
      },

      error: {
        init: function(response) {},
        initSources: function(response) {},
        complete: function(response) {
          $scope.programsListAdminOrder.notice.showErrorMessages([{
            message: response.data.error
          }]);
        }
      }
    };

    $scope.programsListAdminOrder.init();

}]);